// project import
import { NavItemType } from 'types/menu';
import { getGeneralGroup, getTcCopierGroup, getTradingToolsGroup, growthMonetizationGroup, getTcAnalyzerGroup } from './menu-items';
import useAuth from '../hooks/useAuth';

// ==============================|| MENU ITEMS ||============================== //

const useMenuItems = (): { items: NavItemType[] } => {
  const { user } = useAuth();
  const hasAnalyzerRole = user?.roles?.includes('Analyzer') || false;
  
  // Check if user is a free user (not Admin and not Paid Member)
  const isFreeUser = !user?.roles?.includes('Admin') && !user?.roles?.includes('Paid Member');
  
  // If user has Analyzer role, show TC ANALYZER before TRADING TOOLS
  // If not, show it after TRADING TOOLS
  const items = hasAnalyzerRole
    ? [getGeneralGroup(isFreeUser), getTcCopierGroup(isFreeUser), getTcAnalyzerGroup(hasAnalyzerRole), getTradingToolsGroup(isFreeUser)]
    : [getGeneralGroup(isFreeUser), getTcCopierGroup(isFreeUser), getTradingToolsGroup(isFreeUser), getTcAnalyzerGroup(hasAnalyzerRole)];
  
  return { items };
};

// Bottom menu items (Growth & Monetization)
const bottomMenuItems: { items: NavItemType[] } = {
  items: [growthMonetizationGroup]
};

export default useMenuItems;
export { bottomMenuItems };
